<template>
  <div id="regMenu">
    {{$t('cmsg.noAccount')}}
    <el-dropdown style="margin-top: 10px;" @command="regNow">
      <span>
        {{$t('cmsg.signup')}}
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="regHospital">{{$t('cmsg.regHospital')}}</el-dropdown-item>
        <el-dropdown-item command="regPersonal">{{$t('cmsg.regPersonal')}}</el-dropdown-item>
        <el-dropdown-item command="regLab">{{$t('cmsg.regLab')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "reg-menu",
  data() {
    return {};
  },
  methods: {
    regNow(routeName) {
      console.log(routeName);
      // windows.location=this.$router.resolve({name: routeName}).href;
      this.$redirect({ name: routeName });
    }
  }
};
</script>
<style lang="scss">
#regMenu {
  .el-dropdown {
    span.el-dropdown-selfdefine {
      cursor: pointer;
    }
  }
}
</style>
